<template>
  <section class="app-main" ref="sectionContent">
    <transition mode="out-in" name="fade-transform">
      <keep-alive :include="keepAliveIncludes">
        <router-view :key="key"/>
      </keep-alive>
<!--      <router-view/>-->
    </transition>

    <!-- 悬浮按钮 -->
    <el-button
      type="primary"
      icon="el-icon-arrow-up"
      @click="scrollToTop"
      class="floating-button">
    </el-button>

  </section>
</template>

<script>
export default {
  name: "AppMain",
  props: {},
  components: {},
  data() {
    return {}
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      this.scrollToSectionTop();
    },
    scrollToSectionTop() {
      this.$nextTick(() => {
        const section = this.$refs.sectionContent;
        if (section) {
          section.scrollTop = 0;
        }
      });
    },
    scrollToTop() {
      const section = this.$refs.sectionContent;
      if (section) {
        section.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }

  },
  computed: {
    key() {
      return this.$route.name;
    },
    keepAliveIncludes(){
      return this.$store.state.app.keepAliveIncludes
    },
  },
  watch: {},
  mounted() {
  }
}
</script>

<style scoped lang="scss">
@import "./AppMain";

.floating-button {
  position: fixed;
  bottom: 30px; /* 距离底部30px */
  right: 30px; /* 距离右侧30px */
  z-index: 1000;
  background-color: #409EFF; /* 按钮背景色 */
  color: #fff; /* 按钮文字颜色 */
  border-radius: 50%; /* 圆形按钮 */
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2); /* 按钮阴影 */
}

</style>
